var voted_users_rtlignore_default = {
  "container": "IkNpy",
  "webview": "jkLhL",
  "avatar_list": "OVg4F",
  "avatar": "z202P",
  "user_avatar": "norPc",
  "modal": "qxuq3",
  "voted_users_modal": "O3sRb",
  "overlay": "hW1e-",
  "user_card": "GQU0b",
  "user_name": "_0ANas",
  "voted_users_modal_header": "_-3x3k",
  "cta": "BDgGD",
  "close_icon": "_0CwcN",
  "title": "vDldb",
  "member_list_container": "y-QXe",
  "member_list": "gufk8",
  "loader": "nPVwp",
  "anonymous_counter": "Yn--1",
  "spinner": "Zk9uE",
  "spin": "-vf-V"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
